export default __webpack_public_path__ + "static/media/banner_Terms_of_Use.7a3b27a0.jpg";